import React from "react";
import CommonFormBuilder from "../CommonComponenets/FormBuilder";

const LEFT_CIRCLE_FIELDS = [
  { name: "circle_1", top: "210px", left: "95px",  width: "60px", height: "60px" },
  { name: "circle_2", top: "290px", left: "95px",  width: "60px", height: "60px" },
  { name: "circle_3", top: "370px", left: "95px",  width: "60px", height: "60px" },
  { name: "circle_4", top: "450px", left: "95px",  width: "60px", height: "60px" },
  { name: "circle_5", top: "530px", left: "95px",  width: "60px", height: "60px" }
];

// const LOWER_LIMB_FIELDS = [
//   { name: "thigh",  top: "210px", left: "840px", width: "180px", height: "40px" },
//   { name: "knee",   top: "300px", left: "840px", width: "180px", height: "40px" },
//   { name: "leg",    top: "395px", left: "840px", width: "180px", height: "40px" },
//   { name: "ankle",  top: "490px", left: "840px", width: "180px", height: "40px" },
//   { name: "foot",   top: "585px", left: "840px", width: "180px", height: "40px" }
// ];

const MIDDLE_FIELDS = [
  { name: "mid_1", top: "315px", left: "560px", width: "90px", height: "40px" },
  { name: "mid_2", top: "560px", left: "560px", width: "90px", height: "40px" }
];




// const LOWER_LIMB_IMAGE_FIELDS = [
//   {
//     name: "thigh",
//     placeholder: "",
//     top: "170px",
//     left: "610px",
//     width: "160px",
//     height: "38px"
//   },
//   {
//     name: "knee",
//     placeholder: "",
//     top: "260px",
//     left: "610px",
//     width: "160px",
//     height: "38px"
//   },
//   {
//     name: "leg",
//     placeholder: "",
//     top: "350px",
//     left: "610px",
//     width: "160px",
//     height: "38px"
//   },
//   {
//     name: "ankle",
//     placeholder: "",
//     top: "445px",
//     left: "610px",
//     width: "160px",
//     height: "38px"
//   },
//   {
//     name: "foot",
//     placeholder: "",
//     top: "535px",
//     left: "610px",
//     width: "160px",
//     height: "38px"
//   }
// ];






const LOWER_LIMB_FIELDS = [
  { name: "thigh", label: "A" },
  { name: "knee", label: "B" },
  { name: "leg", label: "C" },
  { name: "ankle", label: "D" },
  { name: "foot", label: "E" },
  { name: "leg", label: "F" },
  { name: "ankle", label: "G" },
  { name: "foot", label: "H" },
  { name: "foot", label: "I" }
];



 const LE_ORTHOTICS_PRESCRIPTION_SCHEMA = {
  title: "Lower Extremity Orthotics Prescription",
  sections: [
    {
      title: "Orthotics Devices",
      fields: [
        {
          name: "le_orthotics_devices",
          label: "Select Orthotics Devices",
          type: "checkbox-group",
          options: [
            { label: "Solid Ankle Foot Orthosis", value: "solid_afo" },
            { label: "Hinged Ankle Foot Orthosis", value: "hinged_afo" },
            { label: "KAFO", value: "kafo" },
            { label: "PTB-AFO", value: "ptb_afo" },
            { label: "GRAFO", value: "grafo" },
            { label: "Custom Made Total Contact Insole", value: "tci" },
            { label: "Hinged Knee Brace", value: "hinged_knee_brace" },
            { label: "Post Op Knee Brace", value: "post_op_knee_brace" },
            { label: "Functional Knee Brace", value: "functional_knee_brace" }
          ]
        }
      ]
    },
//     {
//   title: "Affected Areas",
//   fields: [
//     {
//       name: "affected_areas_lower_limb",
//       label: "Affected Areas",
//       type: "image-anatomy-selector",
//       image: "/lowerlimb.png",
//       markers: LOWER_LIMB_FIELDS
//     }
//   ]
// },

    {
      title: "Remarks",
      fields: [
        {
          name: "le_orthotics_remarks",
          label: "",
          type: "textarea"
        }
      ]
    }
  ]
};

export default function LowerExtremityOrthoticsPrescription({
  values,
  onChange
}) {
  return (
    <CommonFormBuilder
      schema={LE_ORTHOTICS_PRESCRIPTION_SCHEMA}
      values={values}
      onChange={onChange}
      layout="nested"
    />
  );
}
